import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';
import { Filing } from '../../../molecules';

interface PurchaseFilingModalProps {
  isOpen: boolean;
  onClose: () => void;
  filing: Filing;
  bookingUrl?: string;
}

export const PurchaseFilingModal = ({
  isOpen,
  onClose,
  filing,
  bookingUrl = 'https://meetings.hubspot.com/spencer318/consultation-with-commenda',
}: PurchaseFilingModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        onClick={(e) => e.stopPropagation()}
        preventCloseOnOutsideClick
        className="max-w-[400px]"
      >
        <DialogHeader className="border-b-0 flex flex-col items-start gap-xs pr-16">
          <DialogTitle>Purchasing a filing</DialogTitle>
          <DialogDescription className="txt-small-regular text-fg-tertiary">
            To purchase{' '}
            <span className="font-semibold">{filing.filingName}</span>, please
            contact your account manager. You can schedule a call at your
            convenience to discuss the next steps.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="border-t-0">
          <Button size="md" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="md"
            variant="primary"
            onClick={() => window.open(bookingUrl, '_blank')}
          >
            Book a call
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
